export function LogoMark({ className = "h-10 w-10" }) {
    return (
        <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#0D52CE" />
            <path
                d="M45 17 A 13.5 13.5 0 1 0 32 30 A 13.5 13.5 0 1 1 19 43"
                stroke="white"
                strokeWidth="10"
                strokeLinecap="round"
                fill="none"
            />
            <rect x="35" y="23" width="10.5" height="19" rx="5.25" fill="#F59E0B" transform="rotate(20 40 32)" />
        </svg>
    );
}

export default function Logo({ dark = false }) {
    return (
        <span className="inline-flex items-center gap-3">
            <LogoMark />
            <span className="leading-[1.08]">
                <span className={`block font-display text-[21px] font-extrabold tracking-tight ${dark ? "text-white" : "text-azul-600"}`}>
                    Smart
                </span>
                <span className={`block font-display text-[15px] font-normal tracking-tight ${dark ? "text-white/85" : "text-azul-500"}`}>
                    benefícios
                </span>
            </span>
        </span>
    );
}
